module.exports = __webpack_public_path__ + "img/spezia-logo-icon.4e6bc793.png";